<div class="page-container">
    <div class="buttons-container">
        <div class="button" data-cy="recents-create-new-shipyard-folder-button" (click)="createBuilder()">
            <mat-icon svgIcon="folder" class="button-icon" />
            {{ 'recent.button.new-builder' | translate }}
        </div>
        <div class="button" data-cy="recents-create-new-vessel-folder-button" (click)="createVessel()">
            <mat-icon svgIcon="vessel-folder" class="button-icon" />
            {{ 'recent.button.new-vessel' | translate }}
        </div>
    </div>

    <div class="body">
        <div class="notifications-container">
            <div class="container-title" data-cy="recents-notifications-header">
                {{ 'recent.notifications.title' | translate }}
            </div>
            <div class="notifications-wrapper" data-cy="recents-notifications-list">
                <app-homepage-notification *ngFor="let notification of notifications" [notification]="notification">
                </app-homepage-notification>
            </div>
        </div>
        <div class="projects-access-container">
            <div class="container-title">
                <div data-cy="recents-project-access-header">
                    {{ 'recent.projects-access.title' | translate }}
                </div>
                <div class="icons-container">
                    <mat-icon
                        svgIcon="grid"
                        class="icon"
                        data-cy="recents-grid-view-icon"
                        [ngClass]="{ icon_active: displayGridView }"
                        (click)="updateViewOption(true)" />
                    <mat-icon
                        svgIcon="list"
                        class="icon"
                        data-cy="recents-list-view-icon"
                        [ngClass]="{ icon_active: !displayGridView }"
                        (click)="updateViewOption(false)" />
                </div>
            </div>
            <div class="filters-container">
                <div class="filter">
                    <div
                        class="selector"
                        data-cy="recents-shipyard-filter"
                        (click)="
                            $event.stopPropagation(); showVesselsList = false; showShipyardsList = !showShipyardsList
                        ">
                        <input [value]="getShipyardValue()" readonly class="selector-input" />
                        <mat-icon class="arrow" svgIcon="dropdown-arrow" [ngClass]="{ transform: showShipyardsList }" />
                    </div>

                    <div #shipyardListElem *ngIf="showShipyardsList" class="select-list-container">
                        <div
                            *ngFor="let item of getShipyardList()"
                            class="select-list"
                            data-cy="recents-shipyard-filter-item"
                            (click)="selectShipyard(item); $event.stopPropagation()">
                            <mat-checkbox
                                [ngModel]="shipyardIsSelected(item)"
                                (click)="selectShipyard(item); $event.stopPropagation()"
                                class="recent-checkbox">
                            </mat-checkbox>
                            <div>{{ item }}</div>
                        </div>
                    </div>
                </div>
                <div class="filter">
                    <div
                        class="selector"
                        data-cy="recents-vessel-filter"
                        [ngClass]="{
                            disabledSelector: selectedShipyardsName.length == 0,
                        }"
                        (click)="showVesselList(); $event.stopPropagation()">
                        <input [value]="getVesselValue()" readonly class="selector-input" />
                        <mat-icon class="arrow" svgIcon="dropdown-arrow" [ngClass]="{ transform: showVesselsList }" />
                    </div>

                    <div *ngIf="showVesselsList" class="select-list-container" #vesselListElem>
                        <div
                            *ngFor="let item of getVesselList()"
                            class="select-list"
                            data-cy="recents-vessel-filter-item"
                            (click)="selectVessel(item); $event.stopPropagation()"
                            [class.disabledOption]="isVesselOptionDisabled(item)">
                            <mat-checkbox
                                [disabled]="isVesselOptionDisabled(item)"
                                [ngModel]="vesselIsSelected(item)"
                                (click)="selectVessel(item); $event.stopPropagation()"
                                class="recent-checkbox">
                            </mat-checkbox>
                            <div class="vessel-name">{{ item }}</div>
                        </div>
                    </div>
                    <div
                        *ngIf="selectedShipyardsName.length == 0"
                        class="disabled-text"
                        data-cy="recents-vessel-filter-no-shipyard-text">
                        {{ 'recent.projects-access.filter.vessels.disabled' | translate }}
                    </div>
                </div>
            </div>
            <ng-container *ngIf="selectedShipyardsName.length > 0">
                <button class="clear-filter-section" (click)="clearFilters()" data-cy="recents-clear-filter-button">
                    {{ 'recent.projects-access.filter.clear' | translate }}
                </button>
            </ng-container>
            <ng-container *ngIf="selectedShipyardsName.length > 0 && filteredVessels.length == 0">
                <div class="empty-filter-section">
                    {{ 'recent.projects-access.filter.empty-list' | translate }}
                </div>
            </ng-container>
            <div *ngIf="displayGridView" class="vessel-grid">
                <ng-container *ngFor="let vessel of filteredVessels">
                    <app-vessel-information-grid
                        [vessel]="vessel"
                        [shipyardName]="vessel.shipyardName"
                        [vesselEditors]="vesselsEditors[vessel.id]"></app-vessel-information-grid>
                </ng-container>
            </div>
            <div div *ngIf="!displayGridView" class="vessel-list">
                <ng-container *ngFor="let vessel of filteredVessels">
                    <app-vessel-information-list
                        [vessel]="vessel"
                        [shipyardName]="vessel.shipyardName"
                        [vesselEditors]="vesselsEditors[vessel.id]"></app-vessel-information-list>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ng-container *ngIf="isLoading"> <app-loading-spinner class="spinner-loading"></app-loading-spinner></ng-container>
